import styled from '@emotion/styled'
import { RadioGroup } from 'components/patterns'

export const StyledRadioGroup = styled(RadioGroup)`
  margin-top: 20px;
`
